import type { NoddiAsyncError } from 'noddi-types';
import { ApiErrorMessageInternal, NoddiInfoBanner } from 'noddi-ui-web';

type Props = {
  error: NoddiAsyncError | null;
  /**
   * Shown instead of the backend detail on a 403. The API answers in English
   * with a rule the member cannot act on; this says who to ask, translated.
   */
  forbiddenMessage?: string;
};

export const MemberSheetError = ({ error, forbiddenMessage }: Props) => {
  if (!error) {
    return null;
  }
  if (forbiddenMessage && error.response?.status === 403) {
    return <NoddiInfoBanner variant='error' texts={[{ value: forbiddenMessage }]} />;
  }
  return <ApiErrorMessageInternal error={error} />;
};
